import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		justifyContent: 'center',
		flexWrap: 'wrap',
		flexDirection: 'column',
		listStyle: 'none',
		padding: 0.5,
		margin: 0,
		position: 'absolute',
		top: '35vh',
		right: 10,
		zIndex: 1000,
		backgroundColor: 'transparent',
		boxShadow: 'none',
	},
	tool: {
		display: 'flex',
		alignItems: 'center',
		width: 38,
		borderRadius: 23,
	},
}))

/**
 * Public zoom controls matching the exact style from ContainerControlRightBottom
 * Just zoom in/out buttons without measure tool or auth dependencies
 */
export default function PublicZoomControls({ mapInfo }) {
	const classes = useStyles()

	return (
		<Paper className={classes.root} component="ol">
			{/* Zoom In Button - exact styling from ContainerControlRightBottom */}
			<li key="search-control-1">
				<Paper className={classes.tool}>
					<IconButton onClick={() => mapInfo?.zoomIn()}>
						<AddIcon style={{ fontSize: 15 }} />
					</IconButton>
				</Paper>
			</li>

			{/* Zoom Out Button - exact styling from ContainerControlRightBottom */}
			<li key="search-control-2">
				<Paper className={classes.tool}>
					<IconButton onClick={() => mapInfo?.zoomOut()}>
						<RemoveIcon style={{ fontSize: 15 }} />
					</IconButton>
				</Paper>
			</li>
		</Paper>
	)
}